import React, { useState } from "react";
import { Card, CardImg, CardBody, Button, Form, FormGroup, Input, Label, Alert } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { login } from "../services/auth.service";

import logo from "../images/JUAN-STREAM-FULL-LOGO.png";

// App version
const APP_VERSION = "0.2.0";

const Login = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const onChangeUsername = (e) => {
    const username = e.target.value;
    setUsername(username);
  };
  const onChangePassword = (e) => {
    const password = e.target.value;
    setPassword(password);
  };
  const handleLogin = (e) => {
    e.preventDefault();
    login(username, password).then((data) => {
      if (data.token) {
        navigate("/addvideo");
      } else {
        setMessage(data.msg);
        setTimeout(() => {
          setMessage("");
        }, 2000);
      }
    });
  };
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      gap: '2rem',
      padding: '2rem'
    }}>
      <div style={{
        textAlign: 'center'
      }}>
        <img
          src="https://image.mux.com/I96adk3IIW2KWQceli02tiAMjfUsrKV9ox6GZQ00j00yB00/animated.gif?start=118"
          alt="Loading animation"
          style={{
            height: '500px',
            width: 'auto'
          }}
        />
      </div>
      <Card
        style={{
          width: "20rem",
        }}
      >
        <CardImg alt="image" src={logo} top width="100%" />
        <CardBody>
          {message && <Alert color="danger" fade={false}>{message}</Alert>}
          <Form inline onSubmit={handleLogin}>
            <FormGroup floating>
              <Input
                id="username"
                name="username"
                placeholder="Username"
                type="text"
                onChange={onChangeUsername}
                required
              />
              <Label for="username">Username</Label>
            </FormGroup>{" "}
            <FormGroup floating>
              <Input
                id="password"
                name="password"
                placeholder="Password"
                type="password"
                onChange={onChangePassword}
                required
              />
              <Label for="password">Password</Label>
            </FormGroup>{" "}
            <Button
              style={{
                width: "10rem",
                background: "#000",
                color: "white",
                border: "none",
                fontWeight: "700",
                fontSize: "20px",
                transform: "translate(40%,30%)",
                marginBottom: "2rem",
              }}
            >
              Login
            </Button>
          </Form>
        </CardBody>
        <div style={{
          textAlign: 'center',
          padding: '0.5rem',
          fontSize: '12px',
          color: '#888',
          borderTop: '1px solid #eee'
        }}>
          v{APP_VERSION}
        </div>
      </Card>
    </div>

  );
};

export default Login;
